import React, { useEffect, useRef, useState } from 'react';
import products from '../data/products';
import { masterReply, GREETING } from './masterBrain';

const productById = (id) => products.find((p) => p.id === id);

// 商品ミニカード（チャット内でマスターが差し出す）
const ChatProductCard = ({ product }) => (
  <a className="mv-chat__card" href={product.url} target="_blank" rel="noopener noreferrer">
    <img src={product.img} alt={product.nameJa} />
    <div>
      <div className="mv-chat__card-name">{product.nameJa}</div>
      <div className="mv-chat__card-meta">{product.weight}　{product.price}</div>
      <div className="mv-chat__card-buy">BASEで見る →</div>
    </div>
  </a>
);

const MasterChat = ({ onClose }) => {
  const [messages, setMessages] = useState([{ from: 'master', ...GREETING }]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const bodyRef = useRef(null);
  const timerRef = useRef(null);

  // 新着メッセージで一番下までスクロール
  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages, typing]);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const send = (text) => {
    const trimmed = text.trim();
    if (!trimmed || typing) return;
    setMessages((prev) => [...prev, { from: 'user', text: trimmed }]);
    setInput('');
    setTyping(true);
    timerRef.current = setTimeout(() => {
      const reply = masterReply(trimmed);
      setMessages((prev) => [...prev, { from: 'master', ...reply }]);
      setTyping(false);
    }, 600 + Math.random() * 500);
  };

  const lastMaster = [...messages].reverse().find((m) => m.from === 'master');
  const quickReplies = !typing && lastMaster ? lastMaster.quickReplies || [] : [];

  return (
    <div className="mv-popup-backdrop" onClick={onClose}>
      <div className="mv-popup mv-chat" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="mv-popup__close" onClick={onClose} aria-label="閉じる">×</button>

        <div className="mv-chat__header">
          <span className="mv-chat__avatar">☕</span>
          <div>
            <div className="mv-chat__title">マスター</div>
            <div className="mv-chat__sub">GURI COFFEE</div>
          </div>
        </div>

        <div className="mv-chat__body" ref={bodyRef}>
          {messages.map((m, i) => (
            <div key={i} className={`mv-chat__msg mv-chat__msg--${m.from}`}>
              <div className="mv-chat__bubble">
                {m.text.split('\n').map((line, j) => (
                  <p key={j}>{line}</p>
                ))}
              </div>
              {(m.productIds || []).map((id) => {
                const p = productById(id);
                return p ? <ChatProductCard key={id} product={p} /> : null;
              })}
            </div>
          ))}
          {typing && (
            <div className="mv-chat__msg mv-chat__msg--master">
              <div className="mv-chat__bubble mv-chat__bubble--typing">
                <span />
                <span />
                <span />
              </div>
            </div>
          )}
        </div>

        {quickReplies.length > 0 && (
          <div className="mv-chat__quick">
            {quickReplies.map((q) => (
              <button key={q} type="button" onClick={() => send(q)}>{q}</button>
            ))}
          </div>
        )}

        <form
          className="mv-chat__input"
          onSubmit={(e) => {
            e.preventDefault();
            send(input);
          }}
        >
          <input
            type="text"
            value={input}
            placeholder="マスターに話しかける…"
            onChange={(e) => setInput(e.target.value)}
          />
          <button type="submit" disabled={!input.trim() || typing}>送信</button>
        </form>
      </div>
    </div>
  );
};

export default MasterChat;
